import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import injectTapEventPlugin from "react-tap-event-plugin";
import { library as fontAwesomeLibrary } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";

import * as session from "./modules/session/actions";

import configureStore, { history } from "./store";

import App from "./containers/App";

injectTapEventPlugin();
fontAwesomeLibrary.add(fas, far, fal);

const store = configureStore();
store.dispatch(session.loadSavedAuth());

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Route component={App} />
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js